import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import DescriptionField from "components/support/description-field";
import Moment from "moment";

export default class CompanyAccountantInfo extends Component {
  static CrtMeanings = {
    1: "Simples Nacional",
    2: "Simples Nacional – excesso de sublimite de receita bruta",
    3: "Regime Normal"
  };

  static CrtNotPresent = "Não informado";

  certificateInfo = () => {
    const { company } = this.props;
    const certificate_info = company.certificate_info || {};
    const raw_uploaded_at = certificate_info.uploaded_at;
    const raw_expiry_date = certificate_info.expiry_date;
    const subject = certificate_info.subject;

    const uploaded_at = raw_uploaded_at
      ? Moment(raw_uploaded_at).format("HH:mm DD/MM/YYYY")
      : "Nunca";
    const expiry_date = raw_expiry_date
      ? Moment(raw_expiry_date).format("HH:mm DD/MM/YYYY")
      : "-";

    return (
      <Row>
        <Col xs={12} md={4}>
          <DescriptionField label="Data do Upload" value={uploaded_at} />
        </Col>
        <Col xs={12} md={4}>
          <DescriptionField label="Subject" value={subject} />
        </Col>
        <Col xs={12} md={4}>
          <DescriptionField label="Data de Expiração" value={expiry_date} />
        </Col>
      </Row>
    );
  };

  render() {
    const { company } = this.props;
    const fiscal_informations = company.fiscal_informations || {};
    const crt =
      CompanyAccountantInfo.CrtMeanings[fiscal_informations.crt_code] ||
      CompanyAccountantInfo.CrtNotPresent;
    return (
      <div className="grid-container">
        <Row>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="Email da Contabilidade"
              value={fiscal_informations.accountant_email}
            />
          </Col>
          <Col xs={12} sm={6}>
            <DescriptionField label="CRT" value={crt} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="Código IEST"
              value={fiscal_informations.iest_code}
            />
          </Col>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="Código CNAE"
              value={fiscal_informations.cnae_code}
              mask={[/\d/, /\d/, /\d/, /\d/, "-", /\d/, "/", /\d/, /\d/]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <DescriptionField label="CSC" value={fiscal_informations.csc} />
          </Col>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="ID do CSC"
              value={fiscal_informations.csc_id}
            />
          </Col>
        </Row>
        <Row>
          <Col xs>
            <h4 style={{ marginLeft: 4 }}>
              Informações do Certificado Digital
            </h4>
            {this.certificateInfo()}
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/accountant-info/index.jsx